// Libelles de statut AFFICHES a l'utilisateur, par source (BC / MS).
//
// La base porte des noms techniques qui ne doivent jamais etre lus tels quels : un bon de commande
// accepte est "Validé" (statut 7), un marche subsequent accepte est "Valider" (statut 11), un BC en
// brouillon est "Brouillon acheteur" (statut 1).
//
// Ce remappage n'existait QUE dans le tableau des operations, en dur. Ni le SuiviHeader ni la liste
// prestataire ne l'appliquaient : le meme dossier s'appelait "Accepté" dans la ligne et "Validé" une
// fois ouvert. Cette table est desormais la source unique des trois points d'affichage — y ajouter
// une entree la propage partout.
//
// Ne concerne QUE le libelle. Les classes CSS (couleur de pastille) restent derivees du nom brut la
// ou elles le sont deja : les toucher changerait le rendu visuel, pas le vocabulaire.
const LIBELLES_PAR_SOURCE: Record<string, Record<number, string>> = {
  BC: {
    1: 'Brouillon',   // base : "Brouillon acheteur"
    7: 'Accepté',     // base : "Validé"
    8: 'Refusé',
    9: 'Expiré',
    12: 'À relancer', // base : "À analyser"
  },
  MS: {
    6: 'Refusé',
    11: 'Accepté',    // base : "Valider"
    12: 'Expiré',
  },
};

// Nombre de mots conserves avant troncature dans les listes.
const STATUT_MOTS_AFFICHES = 3;

// Tronque un libelle de statut a ses premiers mots, suivis d'une ellipse.
//
// La troncature est faite ICI et non en CSS : le tableau est en `table-layout: auto`, donc une
// colonne dont le contenu est en `nowrap` s'ELARGIT jusqu'a tout afficher — `text-overflow: ellipsis`
// n'a alors jamais l'occasion de se declencher, et la colonne mange la largeur des voisines.
// Couper sur un nombre de MOTS (et non une largeur en pixels) donne en plus un resultat stable d'un
// ecran a l'autre. L'appelant doit exposer le libelle entier au survol (attribut `title`).
export const tronquerLibelleStatut = (libelle: string): string => {
  const mots = libelle.trim().split(/\s+/);
  if (mots.length <= STATUT_MOTS_AFFICHES) return libelle;
  return `${mots.slice(0, STATUT_MOTS_AFFICHES).join(' ')}…`;
};

// Libelle a afficher. Retombe sur le nom brut quand la source est inconnue (BCI), quand l'id manque,
// ou quand le statut n'a pas de remappage — la table ne couvre que les statuts qui en ont besoin.
export const libelleStatut = (
  source: string | undefined | null,
  statusId: number | undefined | null,
  nomBrut: string,
): string => {
  if (!source || statusId === undefined || statusId === null) return nomBrut;
  return LIBELLES_PAR_SOURCE[source]?.[statusId] ?? nomBrut;
};
